import { Button, ButtonVariant, Text, TextVariants } from "@next-platform/client-common-spicy-ui";
import { JSX } from "react";

import { cn } from "@/utils";

export interface ButtonGroupAction {
  label: string;
  active?: boolean;
  onClick?: () => void;
  variant?: ButtonVariant;
  disabled?: boolean;
}

type ButtonGroupProps = {
  actions: ButtonGroupAction[];
};

export function ButtonGroup({ actions }: ButtonGroupProps): JSX.Element {
  return (
    <div className="inline-flex flex-row">
      {actions.map(({ label, active, disabled, ...rest }, index) => (
        <Button
          key={index}
          className={cn(
            `first:rounded-l-md rounded-none last:rounded-r-md w-full border-none hover:bg-blue-9 active:bg-gray-2
            group transition-none`,
            (!active || disabled) && "bg-gray-3 dark:bg-gray-2",
            disabled && "hover:cursor-not-allowed",
          )}
          aria-label={`${label}-label`}
          {...rest}
        >
          <Text
            className={cn("text-black dark:text-white group-hover:text-white", active && "text-white")}
            variant={TextVariants.LABEL_MEDIUM_REGULAR}
          >
            {label}
          </Text>
        </Button>
      ))}
    </div>
  );
}
